<template>
    <rkm-overlay>
        <rkm-layout-body title="Agendamento de exame retroativo">
            <template v-slot:actions>

                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click.stop="$refs.Form.openModalPaciente()"
                    color="primary"
                >
                    Atualizar cadastro
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave"
                    @handleExitPaciente="handleExitPaciente"
                    @handleAtualizaPaciente="handleAtualizaPaciente"
                    @loaded="loaded"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/exame-laboratorial/agendamento-exame-retroativo/Form'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Mixins.
import {unmask} from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Form,
        ModalIntegracaoCns
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.paciente && this.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.paciente && this.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.paciente && this.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {

        this.setShowExitFormConfirmation()
    },
    data: () => ({
        additionals: null,
        enums: {classificacao},
        paciente: null,
    }),
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        loaded(value) {
            this.additionals = value.additionals
            this.paciente = value.paciente
        },
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList();
            })
        },
        handleSave(data) {

            this.unsetShowExitFormConfirmation()
            this.redirectToList(data)
        },
        handleExitPaciente() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        handleAtualizaPaciente() {

            this.unsetShowExitFormConfirmation()

            this.$router.push({ name: 'cadastro-paciente-edit', params: { id: this.id } })
        },
        redirectToList(data) {

            this.$router.push({ name: 'exame-laboratorial-agendamento-exame-retroativo-index', params: { item: data } })
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.paciente.cidadaoId,
                nome: this.paciente.nome,
                dataNascimento: this.paciente.dataNascimento,
                nomeMae: this.paciente.nomeMae,
                cns: this.paciente.cns ? this.unMaskCns(this.paciente.cns) : null,
                cpf: this.paciente.cpf ? this.unMaskCpf(this.paciente.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.paciente, {
                nome: item.nome,
                nomeSocial: item.nomeSocial,
                dataNascimento: item.dataNascimento,
                idade: item.idadeFormatada,
                anos: item.idade.anos,
                meses: item.idade.meses,
                dias: item.idade.dias,
                sexoId: item.sexo.id ?? null,
                sexoDescricao: item.sexo.descricao ?? null,
                nomeMae: item.nomeMae,
                cns: item.cns ? this.unMaskCns(item.cns) : null,
                cpf: item.cpf ? this.unMaskCpf(item.cpf) : null,
            })
        },
    },
    mixins: [unmask],
    props: {
        id: { type: Number, default: null }
    },
}
</script>